/**
 * Шкала прогресса с доступным описанием значения.
 *
 * Числа рядом со шкалой — не украшение (ТЗ UI-32): полоса показывает долю, а
 * «сколько ещё» отвечает только счёт. Там, где счёта нет, подпись не
 * выдумывается: пустая шкала без чисел честнее шкалы с нулями.
 */
export interface ProgressBarProps {
  /** Значение от 0 до 1. */
  readonly value: number;
  readonly label: string;
  /** Сделано и всего: показываются вместе или не показываются вовсе. */
  readonly current?: number | undefined;
  readonly total?: number | undefined;
}

export function ProgressBar({ value, label, current, total }: ProgressBarProps): React.JSX.Element {
  const clamped = Math.min(1, Math.max(0, value));
  const percent = Math.round(clamped * 100);
  const counted = current !== undefined && total !== undefined && total > 0;

  const bar = (
    <div
      className="t2x-progress"
      role="progressbar"
      aria-label={label}
      aria-valuenow={percent}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <span className="t2x-progress__fill" style={{ width: `${percent}%` }} />
    </div>
  );

  if (!counted) return bar;

  return (
    <div className="t2x-progress-line">
      {bar}
      <span className="t2x-progress__count">
        {current}/{total}
      </span>
    </div>
  );
}
